const DatatablesActionTypes = {
    DATATABLE_SELECT_START: 'DATATABLE_SELECT_START',
    DATATABLE_SELECT_FINISH: 'DATATABLE_SELECT_FINISH',
    DATATABLE_SELECT_FAILED: 'DATATABLE_SELECT_FAILED',

    DATATABLE_CREATE_START: 'DATATABLE_CREATE_START',
    DATATABLE_CREATE_FINISH: 'DATATABLE_CREATE_FINISH',
    DATATABLE_CREATE_FAILED: 'DATATABLE_CREATE_FAILED',

    DATATABLE_EDIT_START: 'DATATABLE_EDIT_START',
    DATATABLE_EDIT_FINISH: 'DATATABLE_EDIT_FINISH',
    DATATABLE_EDIT_FAILED: 'DATATABLE_EDIT_FAILED',

    DATATABLE_REMOVE_START: 'DATATABLE_REMOVE_START',
    DATATABLE_REMOVE_FINISH: 'DATATABLE_REMOVE_FINISH',
    DATATABLE_REMOVE_FAILED: 'DATATABLE_REMOVE_FAILED',
};

export default DatatablesActionTypes;



// WEBPACK FOOTER //
// src/datatables/DatatablesActionTypes.js